import DataWrapperChart from './DataWrapperChart'
export default DataWrapperChart
